import script from "./MainRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./MainRanking.vue?vue&type=script&setup=true&lang=js"

import "./MainRanking.vue?vue&type=style&index=0&id=e8eb5262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8eb5262"]])

export default __exports__